/*
 * SPDX-FileCopyrightText: © 2023 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

.web {
  background-color: var(--qds-theme-panel-subsection-standard-background);
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  overflow: hidden;

  .content {
    display: flex;
    flex-direction: column;
    padding: var(--qds-navigation-padding-vertical)
      var(--qds-navigation-padding-horizontal)
      var(--qds-navigation-section-padding-vertical)
      var(--qds-navigation-padding-vertical);
  }

  .description {
    font-family: var(--qds-font-family-brand);
    margin-top: 0;
    margin-bottom: 0;
  }

  .header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 56px;
    flex-direction: row-reverse;
  }

  ::slotted([slot="banner"]) {
    margin-top: auto;
    padding: 0 var(--qds-navigation-padding-horizontal)
      var(--qds-navigation-padding-vertical)
      var(--qds-navigation-padding-horizontal);
  }
}

.mobile {
  background-color: var(--qds-theme-navigation-background);
  position: absolute;
  inset: 0;
  overflow: auto;
  z-index: 3;
  padding-bottom: 100px;

  .content {
    display: flex;
    flex-direction: column;
    align-items: start;
    padding: var(--qds-navigation-subsection-gap-children-unrelated);
    gap: var(--qds-navigation-subsection-gap-children-unrelated);
  }

  .description {
    margin: 0;
  }

  .header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 56px;
    flex-direction: row;
  }

  ::slotted([slot="banner"]) {
    padding: var(--qds-navigation-subsection-gap-children-unrelated);
  }
}

qds-standalone-link {
  cursor: pointer;
  height: var(--qds-control-large-height);
}

.header-content {
  display: flex;
  flex-direction: column;
}

.selector-gap {
  display: flex;
  flex-direction: column;
  gap: var(--qds-navigation-padding-vertical)
    var(--qds-navigation-padding-horizontal);
}

.start {
  display: flex;
  gap: 10px;
}

.title-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.hide {
  display: none;
}
